'use client'

/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import { forwardRef, SVGProps, Ref } from 'react'
const SvgNoPassengers = forwardRef((props: SVGProps<SVGSVGElement>, svgRef: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32" ref={svgRef} {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.926 21.822l7.343-7.342.263 4.141a.996.996 0 01-.555.886l-.996.443h-.111l-1.33 9.53c-.111.222-.221.333-.443.333h-.759c-.067 0-.142-.013-.175-.039a.442.442 0 01-.107-.14l-.28-.494-.28.493a.455.455 0 01-.108.141.242.242 0 01-.15.04l-.427-.001h-.374c-.221 0-.442-.111-.442-.333l-1.069-7.658zm-1.86-5.21l.158-4.972a2.992 2.992 0 012.992-2.77h2.88c.496-.002.966.118 1.38.332l-7.41 7.41zM15.546 2a2.88 2.88 0 110 5.76 2.88 2.88 0 010-5.76zM6 23.678L23.678 6l1.414 1.414L7.414 25.092 6 23.678z"
    />
  </svg>
))
export default SvgNoPassengers
